export default {
  header: 'Whoops, you are on an unsupported browser',
  message: 'To get an optimal user experience use one of the following browsers:',
};
